import React, { useEffect, useRef, useState } from 'react';
import { StyledGridVirtualShowroom } from './StyledGridVirtualShowroom';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const GridVirtualShowroom = () => {
 

  useEffect(() => {
    const animImgs = document.querySelectorAll('.anim-img');
    for(var i = 0; i < animImgs.length; i++){

      gsap.to(animImgs[i], {
        duration: .75,
        ease: "power2.easeInOut",
        scale: 1.1,
        scrub: 1,
        scrollTrigger: {
          trigger: animImgs[i],
          start: "top center"
        }
      })

    }
   

  }, [])

  return (
    <React.Fragment>
      {
       
          <StyledGridVirtualShowroom>
            <div className="grid--shelfzone">
              <div className="center--paragraph">
                <h6 className="md--title">Engage and entertain your customers through fully customisable virtual experiences</h6>
              </div>
              <div className="grid-wrap--shelfzone">
                <div className="grid-row--shelfzone">
                  <div className="grid-col--shelfzone grid-col-text--shelfzone">
                    
                    <h6 className="md--title">Build your very own virtual Showroom</h6>
                    <p className="preset-11">Enrich your brand narrative and convert it into an
engaging experience by showcasing your products in
the most innovative way. Design and share your virtual
showroom with anyone, no matter where they are in
the world.</p>
                  </div>
                  <div className="grid-col--shelfzone">
                    <img className="anim-img" src={require('../../assets/shelfzone-grid/grid-1.jpg')} />
                  </div>
                </div>
                <div className="grid-row--shelfzone grid-reverse">
                  <div className="grid-col--shelfzone">
                    <img className="anim-img" src={require('../../assets/shelfzone-grid/grid-2.jpg')} />
                  </div>
                  <div className="grid-col--shelfzone grid-col-text--shelfzone">
                    
                    <h6 className="md--title">Expand your store’s boundaries</h6>
                    <p className="preset-11">Make the most out of your current space and boost your
customer engagement by taking your in-store clients to an
out-of-store VR environment. Make sure you have the entire
product catalog always on hand and bring it all to life with a fully
interactive, immersive and ready to go VR experience.</p>
                  </div>
                </div>
                <div className="grid-row--shelfzone">
                  <div className="grid-col--shelfzone grid-col-text--shelfzone">
                    
                    <h6 className="md--title">Reach the full potential of your retail space</h6>
                    <p className="preset-11">Take advantage of a true to life digital twin of your retail space to maximise
your store performance. Perfect the layout and product placement in your
store by virtualizing and simulating the shopping experience and collecting
all the insights you need to succeed.</p>
                  </div>
                  <div className="grid-col--shelfzone">
                    <img className="anim-img" src={require('../../assets/shelfzone-grid/grid-3.jpg')} />
                  </div>
              </div>
              <div className="grid-row--shelfzone grid-reverse">
                  <div className="grid-col--shelfzone">
                    <img className="anim-img" src={require('../../assets/shelfzone-grid/grid-4.jpg')} />
                  </div>
                  <div className="grid-col--shelfzone grid-col-text--shelfzone">
                    
                    <h6 className="md--title">Become a meta-commerce pioneer</h6>
                    <p className="preset-11">Create your virtual reality store and share it with new consumers all
around the world.
Attract new customers and increase sales by offering the most exciting,
fully virtual interactive shopping experience.</p>
                  </div>
                </div>
              </div>
              
            </div>
            
          </StyledGridVirtualShowroom>
          
      }
    </React.Fragment>
  );
};



export default GridVirtualShowroom;
